// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/sweetalert2/dist/sweetalert2.min.css
// module id = 4
// module chunks = 1